export default __webpack_public_path__ + "static/media/ENGLISH_PUNCTUATION_GRAMMAR.86179d78.svg";